import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Instagram } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-slate-950 border-t border-slate-800 mt-20">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_device-repair-pro-18/artifacts/hify6q1n_ChatGPT%20Image%201%20jun%202026%2C%2002_59_04%20p.m..png"
                alt="KROLBOLT"
                className="h-10 w-auto"
              />
            </div>
            <p className="text-slate-400 mb-4">
              Reparación profesional de celulares, notebooks y computadoras.
            </p>
            <div className="flex gap-3">
              <a 
                href="https://facebook.com/people/Krolbolt/100076340589911" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 hover:text-cyan-400 hover:bg-slate-700 transition-all duration-300"
              >
                <Facebook className="h-4 w-4" />
              </a>
              <a 
                href="https://instagram.com/krolbolt.rio.cuarto" 
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 hover:text-cyan-400 hover:bg-slate-700 transition-all duration-300"
              >
                <Instagram className="h-4 w-4" />
              </a>
            </div>
          </div>

          {/* Links Rápidos */}
          <div>
            <h3 className="text-white font-semibold mb-4">Enlaces Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-slate-400 hover:text-cyan-400 transition-colors">
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-slate-400 hover:text-cyan-400 transition-colors">
                  Servicios
                </Link>
              </li>
              <li>
                <Link to="/shop" className="text-slate-400 hover:text-cyan-400 transition-colors">
                  Tienda
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-slate-400 hover:text-cyan-400 transition-colors">
                  Sobre Nosotros
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-400 hover:text-cyan-400 transition-colors">
                  Contacto
                </Link>
              </li>
            </ul>
          </div>

          {/* Servicios */}
          <div>
            <h3 className="text-white font-semibold mb-4">Servicios</h3>
            <ul className="space-y-2 text-slate-400">
              <li>Reparación de Celulares</li>
              <li>Reparación de Notebooks</li>
              <li>Reparación de Computadoras</li>
              <li>Soluciones de Software</li>
              <li>Microelectrónica</li>
              <li>Mantenimiento Preventivo</li>
            </ul>
          </div>

          {/* Contacto */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contacto</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <Phone className="h-5 w-5 text-cyan-400 flex-shrink-0 mt-0.5" />
                <div>
                  <div className="text-slate-400 text-sm">Teléfono</div>
                  <div className="text-white">+54 358 6019885</div>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="h-5 w-5 text-cyan-400 flex-shrink-0 mt-0.5" />
                <div>
                  <div className="text-slate-400 text-sm">Email</div>
                  <div className="text-white">info@krolbolt.com.ar</div>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-cyan-400 flex-shrink-0 mt-0.5" />
                <div>
                  <div className="text-slate-400 text-sm">Ubicación</div>
                  <div className="text-white">Argentina</div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-slate-800 mt-8 pt-8 text-center">
          <p className="text-slate-400 text-sm">
            © {new Date().getFullYear()} KrolBolt. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;